import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { initPublicEnv } from "@/lib/env";

import "sweetalert2/dist/sweetalert2.min.css";
import "./index.css";

async function bootstrap() {
  const rootEl = document.getElementById("root");
  if (!rootEl) return;

  rootEl.innerHTML =
    '<div style="display:flex;min-height:100vh;align-items:center;justify-content:center;font-family:Arial,sans-serif;color:#52525b;font-size:14px">Đang tải cấu hình…</div>';

  await initPublicEnv();

  const [{ AppProviders }, { App }] = await Promise.all([
    import("@/providers/app-providers"),
    import("@/App"),
  ]);

  createRoot(rootEl).render(
    <StrictMode>
      <AppProviders>
        <App />
      </AppProviders>
    </StrictMode>,
  );
}

void bootstrap();
